export default {
  momentum: 'Momentum',
  value: 'Value',
  growth: 'Growth',
  profitability: 'Profitability',
  quality: 'Quality',
  sentiment: 'Sentiment',
  analyst: 'Analyst',
  fast: 'Fast',
};